<script>
import { formatRequestData } from '@utils/format-date'
import VueCal from 'vue-cal'
import 'vue-cal/dist/i18n/zh-hk.js'
import 'vue-cal/dist/vuecal.css'

export default {
  components: {
    VueCal,
  },
  props: {
    selectedDate: {
      type: Date,
      default: new Date(),
    },
    calendarEvents: {
      type: Array,
      default: () => [],
    },
    disableDays: {
      type: Array,
      default: () => [],
    },
    propsWidth: {
      type: String,
      default: '250px'
    },
    special: {
      type: Boolean,
      default: false
    },
    propsHeight:{
      type: String,
      default: '300px'
    }
  },
  data() {
    return {

    }
  },
  computed: {},
  created() {
    let timeout = setInterval(() => {
      if (this.$refs['cal'] !== undefined) {
        clearInterval(timeout)
        // this.tryToFetchCurrentMonthly()
        this.$emit('rendered', this.getViewInfo())
      }
    }, 300)
  },

  methods: {
    onCellClick(event) {
      if (this.special) {
        this.$emit('updateScheduleItemDays', event)
      }
    },
    onCellFocus($event) {
      this.$emit('update:selectedDate', $event)
      this.$emit('cell-focus', $event)
      // this.$emit('updateHasSchedule', $event) // 本來是更新日曆以排班天數，先拿掉2022/11/18
    },
    // tryToFetchCurrentMonthly() {
    //   const startDate = formatRequestData(this.$refs['cal'].view.startDate)
    //   const endDate = formatRequestData(this.$refs['cal'].view.endDate)
    //   this.tryToFetchMonthly({ startDate, endDate })
    // },
    onViewChange(viewInfo) {
      this.$emit('view-change', viewInfo)
      // if (viewInfo.view !== 'month') return
      // this.tryToFetchMonthly({
      //   startDate: formatRequestData(viewInfo.startDate),
      //   endDate: formatRequestData(viewInfo.endDate),
      // })
    },
    customCellClass(events) {
      if (events.length === 0) return ''
      return events[0].customInfo.orderCount > 0 ? 'is-available' : ''
    },
    getViewInfo() {
      return this.$refs['cal'].view
    },
  },
}
</script>

<template>
  <VueCal ref="cal" class="vuecal--date-picker Jost" :class="special ? 'special' : 'normal'" xsmall="xsmall"
    hide-view-selector="hide-view-selector" active-view="month" locale="zh-hk"
    :style="`width: ${propsWidth};height: ${propsHeight};`" :events="calendarEvents" :selected-date="selectedDate" :time="false"
    :transitions="false" :disable-views="['week', 'day']" :editable-events="false" :disable-days="disableDays"
    click-to-navigate @cell-focus="onCellFocus" @cell-click="onCellClick" @view-change="onViewChange">
    <template v-slot:cell-content="{ cell, events }">
      <slot :data="{ cell, events }"></slot>
      <span class="vuecal__cell-date" :class="customCellClass(events)"></span>
    </template>
  </VueCal>
</template>
<style lang="scss">
@import '@src/design/vuecal-override.scss';

.special {
  border: 1px solid $color-line-dark;
  border-radius: $border-radius ;
  :global {
    // 把「今日」的樣式去掉
    .vuecal__cell--today .vuecal__cell-content {
      border: 1px solid white !important;
    }

    // 使用者選取到的日子群的大小
    .vuecal__cell-date.is-available::before {
      background-color: $color-primary !important;
      border: none;
      width: 44px !important;
      height: 44px !important;
    }
    

    // 日子focus時的樣式
    .vuecal__cell-content {
      width: 44px !important;
      height: 44px !important;
      border-radius: 4px;
    }

    // 日子的margin
    .month-view {
      .vuecal__cell {
        margin-top: 5px;
        margin-bottom: 5px;
      }
    }
    // heading的margin
    .vuecal__weekdays-headings {
      .vuecal__heading{
        margin-top: 5px;
        margin-bottom: 10px;
    }
  }
  }
}

.normal {
  :global {
    .vuecal__cell--today .vuecal__cell-content {
      background-color: $color-primary !important;
      color: #fff !important;
      border-color: $color-primary !important;
      width: 26px !important;
      height: 26px !important;

      span {
        color: inherit !important;
      }
    }
  }
}
</style>
<style lang="scss" module></style>
